module.exports = __webpack_public_path__ + "2938bbc7bc700d015e456051c4ba70cf.svg";